import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DeleteConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  isLoading = false,
  clientName = '',
  isMultiple = false,
  count = 0
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-90" onClick={onClose} />
      
      {/* Modal */}
      <div className="fixed inset-0 z-100 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <div className="bg-card border border-border rounded-lg shadow-modal w-full max-w-md">
            {/* Header */}
            <div className="p-6">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-error/10 rounded-full flex items-center justify-center">
                  <Icon name="AlertTriangle" size={24} className="text-error" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-foreground">
                    {isMultiple ? 'Delete Multiple Clients' : 'Delete Client'}
                  </h2>
                  <p className="text-sm text-muted-foreground mt-1">
                    This action cannot be undone
                  </p>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="px-6 pb-6">
              <div className="bg-muted/50 border border-border rounded-lg p-4 mb-6">
                <p className="text-sm text-foreground">
                  {isMultiple ? (
                    <>
                      Are you sure you want to delete <strong>{count} clients</strong>? 
                      This will permanently remove all their data, API keys, and access permissions.
                    </>
                  ) : (
                    <>
                      Are you sure you want to delete <strong>{clientName}</strong>? 
                      This will permanently remove their account, API keys, and all associated data.
                    </>
                  )}
                </p>
                
                <div className="mt-3 space-y-2">
                  <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                    <Icon name="X" size={14} className="text-error" />
                    <span>All API keys will be revoked immediately</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                    <Icon name="X" size={14} className="text-error" />
                    <span>Access to documentation will be removed</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                    <Icon name="X" size={14} className="text-error" />
                    <span>All webhook configurations will be deleted</span>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="flex items-center justify-end space-x-3">
                <Button
                  variant="outline"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
                <Button
                  variant="destructive"
                  onClick={onConfirm}
                  loading={isLoading}
                  iconName="Trash2"
                >
                  {isMultiple ? `Delete ${count} Clients` : 'Delete Client'}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteConfirmModal;